/**
 * Bounded usage telemetry for the two founder calculators
 * (`/founder-resources/founder-equity-calculator` and
 * `/founder-resources/can-i-afford-to-hire-an-employee-calculator`).
 *
 * One event, `founder_calculator`, with only bounded enums: the tool
 * (`equity`/`hiring`), the explicit action (`scenario_export`/
 * `scenario_apply`/`summary_download`) and the deterministic
 * `${tool}_${action}` label. Never amounts, currencies, share values,
 * filenames, account names or arbitrary input. SSR / analytics-disabled is a
 * no-op via {@link emitGaEvent}.
 *
 * Reporting interpretation: each emission counts one explicit successful
 * action (a prepared export, an applied staged scenario, an initiated
 * summary download) — not renders, keystrokes, recalculations, staged-only
 * imports or unique readers. None implies a signup or a business decision.
 */

import { emitGaEvent } from "@/lib/ga-event";
import {
  FOUNDER_CALCULATOR_EVENT_NAME,
  founderCalculatorEventLabel,
  type FounderCalculatorAction,
  type FounderCalculatorTool,
} from "@/lib/calculator-engagement";

export function founderCalculatorEventParams(
  tool: FounderCalculatorTool,
  action: FounderCalculatorAction,
): {
  event_category: "engagement";
  source: "founder_calculators";
  event_label: string;
  tool: FounderCalculatorTool;
  action: FounderCalculatorAction;
} {
  return {
    event_category: "engagement",
    source: "founder_calculators",
    event_label: founderCalculatorEventLabel(tool, action),
    tool,
    action,
  };
}

export function trackFounderCalculator(
  tool: FounderCalculatorTool,
  action: FounderCalculatorAction,
): void {
  emitGaEvent(
    FOUNDER_CALCULATOR_EVENT_NAME,
    founderCalculatorEventParams(tool, action),
  );
}
